"use client";

import { Typography } from "@/components/ui/typography";
import { FAQHelpCards } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { GroupedHelpCardsCarousel } from "@/components/screen/global-components/help";

const FAQHelp = ({ className }: React.ComponentProps<"section">) => {

  return (
    <section
      className={cn("section overflow-hidden bg-white lg:bg-background-secondary", className)}
    >
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-2">
          <Typography variant="heading4" className="md:text-center">
            <h2>Help Topics</h2>
          </Typography>
          <div className="flex md:justify-center text-gray-600 md:max-w-[780px] md:mx-auto">
            <Typography
              variant="subHeadingSm"
              className="md:text-center"
              asChild
            >
              <p>Browse answers to common questions by topic</p>
            </Typography>
          </div>
        </div>
        <GroupedHelpCardsCarousel cards={FAQHelpCards} className="mt-6 md:mt-12" />
      </div>
    </section>
  );
};

export default memo(FAQHelp);
